import React, {FunctionComponent, useEffect, useRef, useState} from 'react';
import classnames from 'classnames';
import Clamp from '@/utils/Clamp';
import StylesType from '@/types/StylesType';
import { Icon } from '@/components';
import { roomTypes } from '@/types/APITypes';

export interface RoomCartProps extends StylesType{
    data: roomTypes;
    onClick: (item: roomTypes) => void;
}

export const RoomCart: FunctionComponent<RoomCartProps> = props => {
  
    const {prefixCls ,data, onClick } = props;
    const ref = useRef(null)
    const [clamp, setClamp] = useState(2)
  
    /* 点击展开按钮 */
    const handleUnfurlOnClick= (e: { stopPropagation: () => void }) => {
        e.stopPropagation()
        setClamp(6-clamp)
    }
  
    useEffect(() => {
        if (document.getElementById('roomText')) {
            Clamp(document.getElementById('roomText'), {clamp})
        }
    })
  
    return (
        <div onClick={() => onClick(data)} className={classnames(prefixCls)} style={{height: clamp === 2 ? '90px' : '120px'}}>
            <p className={classnames(`${prefixCls}-name`)}>
                <span className={classnames(`${prefixCls}-name-Status`,{[`${prefixCls}-name-disable`]: data.roomStatus !== 1})}/>
                {data.roomName}
            </p>
            {data.roomStatus === 1 ?
                <div className={classnames(`${prefixCls}-button`)}>
          进入
                    <Icon rotate={90} className={classnames(`${prefixCls}-img`)}  type='iconup' />
                </div> :
                <div id='roomText' ref={ref} className={classnames(`${prefixCls}-text`)}>{data.roomDescribe}</div>
            }
            {data.roomStatus === 1 ? null : <Icon onClick={handleUnfurlOnClick} rotate={180} type='iconzhandianshouqi' />}
        </div>
    )
}

RoomCart.defaultProps = {
    prefixCls: 'gc-room-card'
}


export default RoomCart;
